/* eslint-disable no-console */
import React from 'react'
import {Card, CardBody, Heading} from '@eggplant-finance/eggplant-uikit-theme'
// import BigNumber from 'bignumber.js/bignumber'
import styled from 'styled-components'
import {Timeline} from 'react-twitter-widgets'
// import { getBalanceNumber } from 'utils/formatBalance'
// import { useTotalSupply, useBurnedBalance } from 'hooks/useTokenBalance'
import useI18n from 'hooks/useI18n';
import TV from '../graph/screen-home.png';
// import { getCakeAddress } from 'utils/addressHelpers'
// import CardValue from './CardValue'
// import { useFarms } from '../../../state/hooks'

const isMobile = window.innerWidth <= 600

const StyledTwitterCard = styled(Card)`
  margin-left: auto;
  margin-right: auto;
`

const TVContainer = styled.div`
  /* width: 250px;
  height: 300px; */
  width: ${() => isMobile ? '250px' : '400px'};
  height: ${() => isMobile ? '370px' : '400px'};

  /* width: 400px;
  height: 400px; */
  position: relative;
`;

const TimelineAlign = styled.div`
  position: absolute;
  /* bottom: 22px;
  left: 29px; */
  bottom: ${() => !isMobile ? '45px' : '140px'};
  left: ${() => !isMobile ? '59px' : '37px'};

  /* bottom: 45px;
  left: 59px; */
  border-radius: 25% 25%;
`

// const Row = styled.div`
//   align-items: center;
//   display: flex;
//   font-size: 14px;
//   justify-content: space-between;
//   margin-bottom: 8px;
// `

const TwitterCard = () => {
    const TranslateString = useI18n()
    // min-height: 184px;
    // min-width: 239px;
    const a = document?.getElementById('twitter-widget-3');
    const c = document?.getElementById('twitter-widget-1');
    const d = document?.getElementById('twitter-widget-2');
    const b = document?.getElementById('twitter-widget-0');

    if(isMobile) {
        console.log(1)
        if(a) {
            console.log(2)
            a.style.maxWidth = '100%';
            a.style.minWidth = '100px';
            a.style.minHeight = '100px';
        }
        if(b) {
            console.log(3)
            b.style.maxWidth = '100%';
            b.style.minWidth = '100px';
            b.style.minHeight = '100px';
        }
        if(c) {
            console.log(4)
            c.style.maxWidth = '100%';
            c.style.minWidth = '100px';
            c.style.minHeight = '100px';
        }
        if(d) {
            console.log(5)
            d.style.maxWidth = '100%';
            d.style.minWidth = '100px';
            d.style.minHeight = '100px';
        }
    }
    if(a) a.style.borderRadius = '22%';
    if(b) b.style.borderRadius = '22%';
    if(c) c.style.borderRadius = '22%';
    if(d) d.style.borderRadius = '22%';

    return (
        <>
            <StyledTwitterCard isTransparent>
                <TVContainer>
                    <img src={TV} alt='tv' style={{width: isMobile ? '260px' : '400px', height: isMobile ? '260px' : '400px'}}/>
                    <TimelineAlign>
                        <Timeline
                            dataSource={{
                                sourceType: 'profile',
                                screenName: 'eggplant_fi',
                            }}
                            options={{
                                height: isMobile ? '140' : '220',
                                chrome: 'noheader, nofooter',
                                width: isMobile ? '174' : '280',
                                // borderRadius: '25',
                                'border-radius': '25%',
                                minWidth: '100',
                                minHeight: '100'
                            }}
                        />
                    </TimelineAlign>
                </TVContainer>
            </StyledTwitterCard>
        </>
    )
}


export default TwitterCard
